__turbopack_context__.v({
  "attributes": "RemoteCollectionFeed-module__4DfPra__attributes",
  "body": "RemoteCollectionFeed-module__4DfPra__body",
  "bold": "RemoteCollectionFeed-module__4DfPra__bold",
  "cardsGrid": "RemoteCollectionFeed-module__4DfPra__cardsGrid",
  "column": "RemoteCollectionFeed-module__4DfPra__column",
  "container": "RemoteCollectionFeed-module__4DfPra__container",
  "emptyState": "RemoteCollectionFeed-module__4DfPra__emptyState",
  "emptyText": "RemoteCollectionFeed-module__4DfPra__emptyText",
  "grid": "RemoteCollectionFeed-module__4DfPra__grid",
  "gridAttrs": "RemoteCollectionFeed-module__4DfPra__gridAttrs",
  "header": "RemoteCollectionFeed-module__4DfPra__header",
  "infiniteScroll": "RemoteCollectionFeed-module__4DfPra__infiniteScroll",
  "loading": "RemoteCollectionFeed-module__4DfPra__loading",
  "root": "RemoteCollectionFeed-module__4DfPra__root",
  "soldHeader": "RemoteCollectionFeed-module__4DfPra__soldHeader",
  "table": "RemoteCollectionFeed-module__4DfPra__table",
  "withAttributes": "RemoteCollectionFeed-module__4DfPra__withAttributes",
});
